<template>
  <page class="home-page">
    <zui-header>
      <logo type="xiaoyanyun" href="/"></logo>
      <h4 class="zui-logo-text">
        |&nbsp;&nbsp;国潮国色 让爱美丽
        <br/>|&nbsp;&nbsp;让家健康 让社会更美好
      </h4>
<!--      <div class="zui-rightcol" @click="openMenu" style="color: #0b8ba5;">◄目录►</div>-->
      <el-dropdown class="zui-rightcol" @command="handleCommand" trigger="click">
        <span class="el-dropdown-link">
          网站导航<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <template v-for="(zbtn,zi) in headBtn">
            <el-dropdown-item :command="zbtn.key" :key="zi">{{zbtn.text}}</el-dropdown-item>
          </template>
        </el-dropdown-menu>
      </el-dropdown>
      <template v-for="(zbtn,zi) in headBtn">
        <zui-button @click="onButtonClick(zbtn.key)" :key="zi" :class="activeFlag(zbtn.key)?'active':''">{{zbtn.text}}</zui-button>
      </template>
    </zui-header>
    <div class="banner vivify fadeIn">
      <h1 class="vivify popIn">&nbsp;&nbsp;</h1>
      <h3 class="vivify popIn">&nbsp;&nbsp;</h3>
    </div>
    <div class="nav clear" id="服务指南">
      <a class="zhichou vivify popIn">
        <div style="width:100%;height:200px;overflow: hidden;">
          <img src="../assets/img/home/second/1.jpg" style="width: 100%;"/>
        </div>
        <div style="text-align:center;">
          <h3>材质优选</h3>
        </div>
      </a>

      <a class="zhichou vivify popIn delay-200">
        <div style="width:100%;height:200px;overflow: hidden;">
          <img src="../assets/img/home/second/2.jpg" style="width: 100%;"/>
        </div>
        <div style="text-align:center;">
          <h3>色彩指南</h3>
        </div>
      </a>
      <a class="plus vivify popIn delay-400">
        <div style="width:100%;height:200px;overflow: hidden;">
          <img src="../assets/img/home/second/3.jpg" style="width: 100%;"/>
        </div>
        <div style="text-align:center;">
          <h3>产品特色</h3>
        </div>
      </a>
    </div>
    <div class="service">
      <h1>
        集涂料研发、生产、销售、涂装平台<br/>
      </h1>
      <h3>
        创立 “艺见饰界” 艺术漆商学院
      </h3>
    </div>
    <div class="c1" id="产品介绍">
      <Carousel></Carousel>
    </div>

    <div style="display: flex;justify-content: center;" id="发展历程">
      <img src="../assets/img/home/history/1.jpg" style="width:60%;">
    </div>

    <div class="apply-hr">
      <h2>
        选择珂立诺，选择优质服务
      </h2>
      <h4>
        行业解决方案咨询和实施，提供咨询、设计及装修服务
      </h4>
    </div>
    <zui-footer/>
  </page>
</template>
<script>
  import '../assets/less/home-page.less'
  import Logo from '../components/portal/Logo'
  import Page from '../components/portal/Page'
  import ZuiHeader from '../components/portal/Header'
  import ZuiFooter from '../components/portal/Footer'
  import ZuiButton from '../components/portal/Button'
  import Util from '../Util'
  import Carousel from "../components/portal/Carousel";
  // import DropList from 'vue-droplist'
  export default{
    components: {
      Carousel, Page, Logo, ZuiHeader, ZuiFooter,ZuiButton,
      //DropList
    },
    data () {
      return {
        carouselPerPage: (Util.os.android || Util.os.iPhone) ? 1 : 2,
        configData : {
          position: {  // 设置显示位置，position
            top: '60px',
            right: '15px',
            bottom: '',
            left: ''
          },
          width: '40%', // 设置宽度
          list: [ // 设置下拉列表数据和对应的点击事件
            {text: '首页', action: this.gohome},
            {text: '产品服务', action: this.goservice},
            {text: '解决方案', action: this.goplan},
            {text: '典型案例', action: this.gocase},
            {text: '联系我们', action: this.golink}
          ]
        }
      }
    },
    methods: {

    }
  }
</script>
<style>
  .c1{
    width: 80%;
    margin: 0 auto;
  }
</style>
